import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        AlertModule.forRoot(),
        TypeaheadModule.forRoot(),
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
    ],
    exports: [
        TypeaheadModule,
    ]
})
export class SharedModule { }
